export default {
  login: 'SirZeck',
  id: 52738298,
  node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
  avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/SirZeck',
  html_url: 'https://github.com/SirZeck',
  followers_url: 'https://api.github.com/users/SirZeck/followers',
  following_url: 'https://api.github.com/users/SirZeck/following{/other_user}',
  gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
  organizations_url: 'https://api.github.com/users/SirZeck/orgs',
  repos_url: 'https://api.github.com/users/SirZeck/repos',
  events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
  received_events_url: 'https://api.github.com/users/SirZeck/received_events',
  type: 'User',
  site_admin: false,
  name: 'Adit',
  company: null,
  blog: '',
  location: 'India',
  email: null,
  hireable: true,
  bio: 'Learning, Building and Breaking "stuffs"',
  twitter_username: 'urfrndlyneighbr',
  public_repos: 66,
  public_gists: 1,
  followers: 35,
  following: 35,
  created_at: '2019-07-10T08:07:18Z',
  updated_at: '2021-11-04T14:56:58Z',
}
